import React from "react"
import { graphql } from "gatsby"
import _ from "lodash"

import ArticleTeaser from "./article-teaser"

import {
  ArticleTeaserFieldsFragment,
  ArticlesTeaserFieldsFragment,
} from "../../graphql-types"

export const query = graphql`
  fragment ArticlesTeaserFields on DatoCmsArticlesTeaser {
    componentId: key
    title
    articleType
    categories {
      id
      name
    }
  }
`

const filterByArticleType = (
  articles: ArticleTeaserFieldsFragment[],
  articleType: string
): ArticleTeaserFieldsFragment[] => {
  return articleType
    ? articles.filter(article => article.articleType === articleType)
    : articles
}

const filterByCategories = (
  articles: ArticleTeaserFieldsFragment[],
  categories: { id: string; name?: string }[]
): ArticleTeaserFieldsFragment[] => {
  const filtered = []
  const matchMainCategory = (article: ArticleTeaserFieldsFragment) => {
    return (
      article.categories[0] &&
      categories.map(c => c.id).includes(article.categories[0].id)
    )
  }
  const matchAllCategories = (article: ArticleTeaserFieldsFragment) => {
    return _.intersectionBy(categories, article.categories, "id").length > 0
  }
  if (categories && categories.length > 0) {
    articles.forEach(article => {
      if (matchMainCategory(article)) {
        filtered.push(article)
      }
    })
    articles.forEach(article => {
      if (
        matchAllCategories(article) &&
        !filtered.find(added => article.id === added.id)
      ) {
        filtered.push(article)
      }
    })
    return filtered
  } else {
    return articles
  }
}

export interface ArticlesTeaserProps extends ArticlesTeaserFieldsFragment {
  articles: ArticleTeaserFieldsFragment[]
}

const ArticlesTeaser: React.FC<ArticlesTeaserProps> = ({
  componentId,
  title,
  articleType,
  categories,
  articles,
}) => {
  const filtered = filterByCategories(
    filterByArticleType(articles, articleType),
    categories
  ).slice(0, 3)

  return (
    filtered.length > 0 && (
      <section id={componentId} className="o-row" data-faux-href="#">
        <h2 className="c-content-header">{title}</h2>
        <div className="c-articles-teaser o-wrapper">
          {filtered.map(item => (
            <ArticleTeaser article={item} key={item.id} />
          ))}
        </div>
      </section>
    )
  )
}

export default ArticlesTeaser
